export default "__VITE_ASSET__515f6db5__"